import { ModelDefinition } from '../base-components/hooks/useModel';
import { getResource, saveResource, createResourceAndGetId } from '../api/resource-controller';
import { RoutePath } from '@/generic/config';

type Resource = {
    id: number;
    code: string;
    enabled: boolean;
};

export default Resource;

export const emptyResourceObject: Resource = {
    id: 0,
    code: "",
    enabled: true,
};

export const ResourceModel: ModelDefinition<Resource> = {
    getById: getResource,
    saveFromModel: saveResource,
    createFromModel: createResourceAndGetId,
    validationMessages: () => [],
    routePath: RoutePath.Resources,
    typeProviderObject: emptyResourceObject,
};